<template>
  <div class="d-flex justify-content-between">
    <h1>Signaturen</h1>

    <button class="btn" @click="loadSignaturen()"><font-awesome-icon icon="rotate" /></button>
  </div>

  <div class="row mb-3">
    <div class="col-4">
      <router-link v-if="store.getters.isAdmin" :to="{ name: 'EditSignatur' }" class="btn btn-primary"><font-awesome-icon icon="plus" /> Erstellen</router-link>
    </div>

    <div class="col-4">
      <div class="input-group input-group-sm my-auto">
        <input v-model.trim="searchString" type="search" class="form-control" id="searchInput" placeholder="Suche..." />
        <span class="input-group-text">
          <font-awesome-icon icon="magnifying-glass" class="p-1" />
        </span>
      </div>
    </div>
  </div>

  <LoadingSpinner v-if="loading" text="... Signaturen werden geladen ..." />

  <div v-else-if="errorMsg != ''" class="alert alert-danger mt-5">
    Es ist ein Fehler aufgetreten:
    {{ errorMsg }}
  </div>

  <div v-if="signaturen.length > 0" class="mt-2">
    <div class="row mx-1 mb-2 bg-white shadow-sm">
      <div class="col-3 py-2 table-col">
        <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
          <strong>Name</strong>

          <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'unterschriftasc'" class="text-secondary table-sort-icon" />
          <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'unterschriftdesc'" class="text-secondary table-sort-icon" />

          <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
            <li class="dropdown-item select-sort" @click="sortBy('unterschriftasc')">
              <div class="row">
                <div class="col-2">
                  <font-awesome-icon icon="check" v-show="sortByValue == 'unterschriftasc'" />
                </div>
                <div class="col">A - Z</div>
              </div>
            </li>
            <li class="dropdown-item select-sort" @click="sortBy('unterschriftdesc')">
              <div class="row">
                <div class="col-2">
                  <font-awesome-icon icon="check" v-show="sortByValue == 'unterschriftdesc'" />
                </div>
                <div class="col">Z - A</div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-2 py-2 table-col">
        <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
          <strong>Zeichnung</strong>

          <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'zeichnungasc'" class="text-secondary table-sort-icon" />
          <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'zeichnungdesc'" class="text-secondary table-sort-icon" />

          <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
            <li class="dropdown-item select-sort" @click="sortBy('zeichnungasc')">
              <div class="row">
                <div class="col-2">
                  <font-awesome-icon icon="check" v-show="sortByValue == 'zeichnungasc'" />
                </div>
                <div class="col">A - Z</div>
              </div>
            </li>
            <li class="dropdown-item select-sort" @click="sortBy('zeichnungdesc')">
              <div class="row">
                <div class="col-2">
                  <font-awesome-icon icon="check" v-show="sortByValue == 'zeichnungdesc'" />
                </div>
                <div class="col">Z - A</div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-3 py-2 table-col">
        <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
          <strong>Funktion</strong>

          <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'funktionsasc'" class="text-secondary table-sort-icon" />
          <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'funktionsdesc'" class="text-secondary table-sort-icon" />

          <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
            <li class="dropdown-item select-sort" @click="sortBy('funktionsasc')">
              <div class="row">
                <div class="col-2">
                  <font-awesome-icon icon="check" v-show="sortByValue == 'funktionsasc'" />
                </div>
                <div class="col">A - Z</div>
              </div>
            </li>
            <li class="dropdown-item select-sort" @click="sortBy('funktionsdesc')">
              <div class="row">
                <div class="col-2">
                  <font-awesome-icon icon="check" v-show="sortByValue == 'funktionsdesc'" />
                </div>
                <div class="col">Z - A</div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-4 py-2 table-col">
        <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
          <strong>Funktion EN</strong>

          <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'funktionENasc'" class="text-secondary table-sort-icon" />
          <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'funktionENdesc'" class="text-secondary table-sort-icon" />

          <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
            <li class="dropdown-item select-sort" @click="sortBy('funktionENasc')">
              <div class="row">
                <div class="col-2">
                  <font-awesome-icon icon="check" v-show="sortByValue == 'funktionENasc'" />
                </div>
                <div class="col">A - Z</div>
              </div>
            </li>
            <li class="dropdown-item select-sort" @click="sortBy('funktionENdesc')">
              <div class="row">
                <div class="col-2">
                  <font-awesome-icon icon="check" v-show="sortByValue == 'funktionENdesc'" />
                </div>
                <div class="col">Z - A</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <SignaturRow v-for="signatur in sortedSignaturen" :key="signatur.id" :signatur="signatur" />
  </div>

  <div v-else-if="!loading && errorMsg == '' && signaturen.length == 0" class="alert alert-info mt-5">Es wurden keine Signaturen gefunden.</div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { computed, ref, onMounted } from 'vue';
  import { useStore } from 'vuex';

  import { ActionTypes as VertragspartnerActionTypes } from '@/store/modules/Vertragspartner/actions';

  import LoadingSpinner from '@/components/LoadingSpinner.vue';
  import SignaturRow from '@/components/Signaturen/SignaturRow.vue';

  import { Signatur } from '@/models/VertragspartnerModels';
  //#endregion

  const store = useStore();

  const loading = computed(() => store.getters.status.getSignaturenLoading);
  const errorMsg = computed(() => store.getters.status.signaturErrorMsg);

  const searchString = ref('');

  const sortByValue = ref('unterschriftasc');
  function sortBy(param: string) {
    sortByValue.value = param;
  }

  const signaturen = computed(() => store.getters.signaturen);
  const sortedSignaturen = computed(() => {
    return signaturen.value
      .filter((v: Signatur) => {
        return (
          v.unterschrift.trim().toLowerCase().includes(searchString.value.trim().toLowerCase()) ||
          v.zeichnung.trim().toLowerCase().includes(searchString.value.trim().toLowerCase()) ||
          v.funktion.trim().toLowerCase().includes(searchString.value.trim().toLowerCase()) ||
          v.funktionEN.trim().toLowerCase().includes(searchString.value.trim().toLowerCase())
        );
      })
      .sort((a: Signatur, b: Signatur) => {
        if (sortByValue.value == 'unterschriftasc' || sortByValue.value == 'unterschriftdesc') {
          var unterschriftComparison = a.unterschrift.trim().toLowerCase().localeCompare(b.unterschrift.trim().toLowerCase());
          if (sortByValue.value == 'unterschriftdesc') {
            unterschriftComparison = -1 * unterschriftComparison;
          }

          if (unterschriftComparison == 0) {
            var zusatzComparison = a.zeichnung.trim().toLowerCase().localeCompare(b.zeichnung.trim().toLowerCase()) || 0;
            return zusatzComparison;
          }

          return unterschriftComparison;
        } else if (sortByValue.value == 'zeichnungasc' || sortByValue.value == 'zeichnungdesc') {
          var zeichnungsComparison = a.zeichnung.trim().toLowerCase().localeCompare(b.zeichnung.trim().toLowerCase()) || 0;

          if (sortByValue.value == 'zeichnungdesc') {
            zeichnungsComparison = -1 * zeichnungsComparison;
          }

          if (zeichnungsComparison == 0) {
            var unterschriftComparison = a.unterschrift.trim().toLowerCase().localeCompare(b.unterschrift.trim().toLowerCase());
            return unterschriftComparison;
          }

          return zeichnungsComparison;
        } else if (sortByValue.value == 'funktionsasc' || sortByValue.value == 'funktionsdesc') {
          var funktionsComparison = a.funktion.trim().toLowerCase().localeCompare(b.funktion.trim().toLowerCase());
          if (sortByValue.value == 'funktionsdesc') {
            funktionsComparison = -1 * funktionsComparison;
          }

          if (funktionsComparison == 0) {
            var unterschriftComparison = a.unterschrift.trim().toLowerCase().localeCompare(b.unterschrift.trim().toLowerCase());
            return unterschriftComparison;
          }

          return funktionsComparison;
        } else if (sortByValue.value == 'funktionENasc' || sortByValue.value == 'funktionENdesc') {
          var funktionENComparison = a.funktionEN.trim().toLowerCase().localeCompare(b.funktionEN.trim().toLowerCase());

          if (sortByValue.value == 'funktionENdesc') {
            funktionENComparison = -1 * funktionENComparison;
          }

          if (funktionENComparison == 0) {
            var unterschriftComparison = a.unterschrift.trim().toLowerCase().localeCompare(b.unterschrift.trim().toLowerCase());
            return unterschriftComparison;
          }

          return funktionENComparison;
        }

        return 0;
      });
  });

  function loadSignaturen() {
    store.dispatch(VertragspartnerActionTypes.GetSignaturen, undefined);
  }

  onMounted(() => {
    loadSignaturen();
  });
</script>

<style scoped>
  .table-col:hover {
    background: rgb(216, 217, 222);
    cursor: pointer;
  }

  .table-sort-icon {
    font-size: 0.7em;
  }

  .select-sort:hover {
    cursor: pointer;
  }
</style>
